import React from 'react';
import FontAwesome5 from 'react-native-vector-icons/FontAwesome5';
import { useTheme } from '../../hooks';
export const FAIcon = React.forwardRef(({ name, size, color, style = {}, solid = true, ...props }, ref) => {
    const theme = useTheme();
    const iconSize = size ? size : theme.fontSizes.h2;
    const iconColor = color ? color : theme.colors.textPrimary;
    return (React.createElement(FontAwesome5, { ref: ref, solid: solid, name: name, size: iconSize, color: iconColor, style: style, ...props }));
});
//# sourceMappingURL=FAIcon.js.map